export {
  registerElementActive,
  registerElementHighlight,
  registerElementSelect,
  registerElementActiveByLegend,
  registerElementHighlightByLegend,
  registerElementHighlightByName,
  registerElementHighlightByGroup,
  registerElementHighlightByKey
} from '@visactor/vgrammar-core';
